// One-line flag controlling the site-wide outage notice. Flip to `false` and
// redeploy the frontend the moment the backend is healthy again. No env var
// needed — keeps the toggle visible in code review and 1-click reversible.
export const OUTAGE_MODE = false;

// Dismissed-banner cookie/storage key. Bumped on every fresh outage so a user
// who dismissed a previous banner sees the new one again.
export const OUTAGE_DISMISS_KEY = 'mfm_outage_dismissed_v1';
